module.exports = __webpack_public_path__ + "static/fakeProductLi2-4c923679c286461b384a57b50d88b2fe.jpg";